export default (state: IKeyValue) => ({
	position: state.position,
});
